const dataColumn = (field, headerName, width, type, editable = false, renderCell ) => {

    return {
        field: field,
        headerName: headerName,
        width: width,
        type: type,
        editable: editable,
        headerAlign: 'center',
        align: 'center',
        renderCell: renderCell,
    };
};

export { dataColumn }
